import React, { useEffect, useState } from "react";
import "../CounsellorAllPages/AvailabilitySelector.css";

const timeSlots = Array.from({ length: 16 }, (_, i) => {
  const hour = 8 + i;
  return `${hour.toString().padStart(2, "0")}:00`;
});

const defaultDays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const AvailableSelector = ({
  visible,
  onClose,
  onSave,
  initialValues = [],
}) => {
  const validInitialValues = Array.isArray(initialValues) ? initialValues : [];

  const [availability, setAvailability] = useState(
    defaultDays.map((day) => {
      const existing = validInitialValues.find((d) => d.day === day);
      return (
        existing || {
          day,
          start: "10:00",
          till: "20:00",
          off_day: "0",
        }
      );
    })
  );

  const updateTime = (index, type, value) => {
    const updated = [...availability];
    updated[index][type] = value;
    setAvailability(updated);
  };

  const toggleOffDay = (index) => {
    const updated = [...availability];
    updated[index].off_day = updated[index].off_day === "1" ? "0" : "1";
    setAvailability(updated);
  };

  if (!visible) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Set Availability</h2>
          <button className="close-btn" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="modal-body">
          {availability.map((item, index) => (
            <div key={index} className="day-row">
              <div className="row-controls">
                <div className="daydiv">
                  <strong className="dayName">{item.day}</strong>
                </div>
                <label>
                  Start:
                  <select
                    value={item.start}
                    onChange={(e) => updateTime(index, "start", e.target.value)}
                  >
                    {timeSlots.map((slot) => (
                      <option key={slot} value={slot}>
                        {slot}
                      </option>
                    ))}
                  </select>
                </label>
                <label>
                  Till:
                  <select
                    value={item.till}
                    onChange={(e) => updateTime(index, "till", e.target.value)}
                  >
                    {timeSlots.map((slot) => (
                      <option key={slot} value={slot}>
                        {slot}
                      </option>
                    ))}
                  </select>
                </label>
                <label>
                  <div className="dayname-checkbox">
                    {/* Off Day: */}
                    {item.off_day === "1" ? (
                      <span className="off-text">On</span>
                    ) : (
                      <span className="on-text">Off</span>
                    )}
                    <input
                      type="checkbox"
                      checked={item.off_day === "1"}
                      onChange={() => toggleOffDay(index)}
                      className="checkboxmodal"
                    />
                  </div>
                </label>
              </div>
            </div>
          ))}
        </div>
        <div className="modal-footer">
          <button className="save-btn" onClick={() => onSave(availability)}>
            Save
          </button>
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AvailableSelector;
